import React, { useState, useEffect } from "react";
import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";
import { get } from "../../../../../utils/api";

const CategoryFilter = ({
  selectedCategories = [],
  setSelectedCategories,
  url,
  errors,
}) => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await get(url);
        const uniqueCategories = response.data.data
          ? [
              ...new Set(
                response.data.data.map(
                  (machinery) => machinery.machineCategory?.type
                )
              ),
            ]
          : [];

        console.log("Unique Categories:", uniqueCategories);
        setCategories(uniqueCategories);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, [url]); // Reload categories when the URL changes

  const handleCategoryChange = (event) => {
    const selectedEquipmentType = event.target.value;
    if (event.target.checked) {
      setSelectedCategories([...selectedCategories, selectedEquipmentType]);
    } else {
      setSelectedCategories(
        selectedCategories.filter(
          (country) => country !== selectedEquipmentType
        )
      );
    }
  };

  return (
    <Box sx={{ m: "5%", mt: 0 }}>
      <Typography
        variant="h5"
        gutterBottom
        sx={{ fontWeight: "bold", marginBottom: "30px" }}
      >
        Machinery Category
      </Typography>
      <Box className="scrollable-container">
        {categories.length > 0 ? (
          categories.map((category, index) => (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  value={category}
                  checked={selectedCategories?.includes(category)}
                  onChange={handleCategoryChange}
                />
              }
              label={category || "Unknown Category"} // Fallback for missing category names
            />
          ))
        ) : (
          <Typography>Loading categories...</Typography>
        )}
      </Box>
      {errors && (
        <Typography variant="body2" color="#D34040" sx={{ mt: 2 }}>
          {errors}
        </Typography>
      )}
    </Box>
  );
};

export default CategoryFilter;
